export function mapErrorsToMessages(errors) {
  return errors.flatMap((e) =>
    Object.values(e.details.errors)
      .map((m) => e.name + ': ' + m)
      .concat(e.details.errorMessages.map((m) => e.name + ': ' + m))
  );
}
